var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 16,
    viewBox: "0 0 16 16",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m3.43433 3.43427c.31242-.31242.81895-.31242 1.13137 0l3.43431 3.43431 3.43429-3.43431c.3124-.31242.819-.31242 1.1314 0s.3124.81895 0 1.13137l-3.43432 3.43431 3.43432 3.43435c.3124.3124.3124.8189 0 1.1313-.3124.3125-.819.3125-1.1314 0l-3.43429-3.43428-3.43431 3.43428c-.31242.3125-.81895.3125-1.13137 0-.31242-.3124-.31242-.8189 0-1.1313l3.43431-3.43435-3.43431-3.43431c-.31242-.31242-.31242-.81895 0-1.13137z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.ae39367c088b854c271d303c985a9608.svg";
export { ForwardRef as ReactComponent };